import React from 'react';
import DashboardCardView from '../view/DashboardCardView';
import { connect } from 'react-redux';

const AVATAR_STYLES = [
  { backgroundColor: '#B4BCF4', secondColor: '#c9cef2', color: 'black' }
  // { backgroundColor: '#CAFF8A', secondColor: '#B1E671', color: 'black' },
  // { backgroundColor: '#ff6666', secondColor: '#E64D4D', color: 'white' },
  // { backgroundColor: '#2f323a', secondColor: '#494C54', color: 'white' },
  // { backgroundColor: '#783f8e', secondColor: '#9259A8', color: 'white' },
  // { backgroundColor: '#8bbeb2', secondColor: '#A5D8CC', color: 'black' }
];

const stringToNumber = (str, limit = 10) => {
  return 0;
  // let i, total;
  // total = 0;
  // for (i = 0; i < str.length; i++) {
  //   total += str.charCodeAt(i);
  // }
  // return total % limit;
};

const DashboardCardEngine = ({ assets, formNode = {} }) => {
  const viewProps = {
    assets,
    formNode,
    avatarStyle:
      AVATAR_STYLES[
        stringToNumber((formNode && formNode.title) || '', AVATAR_STYLES.length)
      ]
  };

  return <DashboardCardView {...viewProps} />;
};

const mapStateToProps = (store, props) => ({
  assets: store.content.assets
});

export default connect(mapStateToProps)(DashboardCardEngine);
